import { jsx as _jsx } from "react/jsx-runtime";
/* eslint-disable */ /* @ts-nocheck */ import React from "react";
import Carousel from "framer-motion-carousel";
var banners = [
    {
        id: 1,
        href: "https://lp.cryptopeso.co/?ref=4yM9BubjA2UF5GcchawsvCtuZknPwygL7fVR1XfxkQSN"
    },
    {
        id: 2,
        href: "https://v3.cryptopeso.co/?ref=0x67c1cdc33cc36b206b0590c238be93ba5cd0dc7a"
    },
    {
        id: 3,
        href: "https://v3.cryptopeso.co/?ref=0x67c1cdc33cc36b206b0590c238be93ba5cd0dc7a"
    },
    {
        id: 4,
        href: "https://copy.cryptopeso.co/?ref=0x67c1CDc33cc36b206B0590C238bE93Ba5Cd0dc7A"
    },
    {
        id: 5,
        href: "https://www.crpbets.co?ref=0x67c1CDc33cc36b206B0590C238bE93Ba5Cd0dc7A"
    }, 
];
function CarouselBanner() {
    return /*#__PURE__*/ _jsx("section", {
        "aria-label": "Promociones",
        "aria-roledescription": "carrusel",
        className: "fixed inset-x-0 top-0 z-[999] overflow-hidden border-b border-amber-400/40 bg-black shadow-[0_8px_28px_rgba(0,0,0,0.35)] lg:relative lg:overflow-visible lg:border-0 lg:bg-transparent lg:px-8 lg:pt-6 lg:shadow-none",
        children: /*#__PURE__*/ _jsx("div", {
            className: "mx-auto max-w-screen-xl lg:max-w-[1440px] lg:overflow-hidden lg:rounded-2xl lg:border lg:border-amber-400/25 lg:bg-black lg:shadow-[0_12px_40px_rgba(0,0,0,0.45),0_0_24px_rgba(251,191,36,0.06)]",
            children: /*#__PURE__*/ _jsx(Carousel, {
                autoPlay: true,
                interval: 7000,
                renderArrowLeft: function() {
                    return null;
                },
                renderArrowRight: function() {
                    return null;
                },
                renderDots: function() {
                    return null;
                },
                children: banners.map(function(banner) {
                    return /*#__PURE__*/ _jsx("div", {
                        className: "relative",
                        children: /*#__PURE__*/ _jsx("a", {
                            href: banner.href,
                            draggable: false,
                            className: "block focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-amber-400",
                            children: /*#__PURE__*/ _jsx("img", {
                                className: "block h-auto w-full select-none object-contain",
                                src: "https://s3.magic-api.xyz/beats-miner-v4/banner-".concat(banner.id, ".png"),
                                alt: "Promoci\xf3n ".concat(banner.id, " de Liquidity Pool \u2014 ver detalles"),
                                draggable: false,
                                decoding: "async"
                            })
                        })
                    }, banner.id);
                })
            })
        })
    });
}
export default CarouselBanner;
